// AUTO-GENERATED by scripts/fetch-facebook-album.js — do not edit by hand.
// Synced daily from the "Website Feed" album on the Neff Paving & Concrete Facebook Page.
// Last sync produced 6 image(s).

export const facebookImages = [
  {
    "filename": "fb-1462733325871597.webp",
    "title": "Community Bank Stripped",
    "alt": "Community Bank Stripped",
    "date": "2026-06-22T03:54:36+0000"
  },
  {
    "filename": "fb-1462733292538267.webp",
    "title": "Community Bank Surface",
    "alt": "Community Bank Surface",
    "date": "2026-06-22T03:54:36+0000"
  },
  {
    "filename": "fb-1462733279204935.webp",
    "title": "Neff Paving & Concrete",
    "alt": "Recent paving, concrete, or excavation work by Neff Paving & Concrete",
    "date": "2026-06-22T03:54:36+0000"
  },
  {
    "filename": "fb-1462733385871591.webp",
    "title": "Community Bank Bottom Center",
    "alt": "Community Bank Bottom Center",
    "date": "2026-06-22T03:54:36+0000"
  },
  {
    "filename": "fb-1462733395871590.webp",
    "title": "Community Bank Top",
    "alt": "Community Bank Top",
    "date": "2026-06-22T03:54:36+0000"
  },
  {
    "filename": "fb-1458305476314382.webp",
    "title": "Website Feed Cover Photo",
    "alt": "Website Feed Cover Photo",
    "date": "2026-06-17T06:39:23+0000"
  }
];
